import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';

@Injectable()
export class EnvironmentService {

    //  Development

    public config;

    constructor() {
        this.config = environment.config;
    }
}


// WEBPACK FOOTER //
// ./src/app/core/services/environment.service.ts